function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("title", null, "arrow_left");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#321e75",
  opacity: 0.62,
  d: "M26.43 3.12L6.58 22.97 25.71 42.1l-2.83 2.83L.93 22.97 23.6.29l2.83 2.83z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 27.17 45.22"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/arrow_left.b2527928.svg";
export { SvgComponent as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/svgr/webpack.js!./src/common/images/arrow_left.svg
// module id = 495
// module chunks = 0